import React from 'react';
import cx from 'classnames';
import { LoadingProgress } from '@vimily/bonjoro-ui-components-v2/LoadingProgress';

export enum TrialPeriodProgressTheme {
  Yellow = 'yellow',
  Blue = 'blue',
  Magenta = 'magenta',
}

export interface TrialPeriodProgressProps {
  className?: string;
  loadingProgressClassName?: string;
  loadingBarClassName?: string;
  progress?: number;
  maxProgress?: number;
  theme?: TrialPeriodProgressTheme;
}

export function TrialPeriodProgress({
  className,
  loadingProgressClassName,
  loadingBarClassName,
  progress = 0,
  maxProgress = 100,
  theme = TrialPeriodProgressTheme.Yellow,
}: TrialPeriodProgressProps) {
  return (
    <div
      className={cx(
        className,
        [
          'block flex flex-row gap-x-3 py-2 px-3 items-center max-w-[375px] rounded',
        ],
        {
          'v2-bg-yellow-50': theme === TrialPeriodProgressTheme.Yellow,
          'v2-bg-blue-50': theme === TrialPeriodProgressTheme.Blue,
          'v2-bg-magenta-50': theme === TrialPeriodProgressTheme.Magenta,
        }
      )}
    >
      <span className='flex flex-row text-base'>
        {`Trial ${progress}/${maxProgress}`}
      </span>
      <LoadingProgress
        progress={progress}
        maxProgress={maxProgress}
        className={cx(loadingProgressClassName, 'h-5 flex-1')}
        progressClassName={cx(loadingBarClassName, {
          'v2-bg-yellow-500': theme === TrialPeriodProgressTheme.Yellow,
          'v2-bg-blue-500': theme === TrialPeriodProgressTheme.Blue,
          'v2-bg-magenta-500': theme === TrialPeriodProgressTheme.Magenta,
        })}
      />
    </div>
  );
}
